const lightBoxHTML = `
    <div class="overlay"></div>

    <div class="window"> 
      <div class="toolbar">
        <div class="counter">1 / 1</div> 
        <div class="zoom-controls">
          <button data-action="zoom-in"><svg aria-hidden="true" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path class="vertical" d="M2.75 7H11.25" stroke="currentColor" stroke-width="var(--icon-stroke-width)" stroke-linecap="round"/>
  <path class="horizontal" d="M7 2.75L7 11.25" stroke="currentColor" stroke-width="var(--icon-stroke-width)" stroke-linecap="round"/>
</svg>
</button>
          <button data-action="zoom-out"><svg aria-hidden="true" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M2.75 7H11.25" stroke="currentColor" stroke-width="var(--icon-stroke-width)" stroke-linecap="round"/>
</svg>
</button>
        
          <button data-action="zoom-fit">
          <svg   fill="currentColor" version="1.1" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
 <path d="m8 26a2 2 0 00-2 2.3 2.1 2.1 0 002.1 1.7h7.1l-10.5 10.5a2 2 0 00-.2 2.8 1.8 1.8 0 001.5.7 2 2 0 001.4-.6l10.6-10.6v7.1a2.1 2.1 0 001.7 2.1 2 2 0 002.3-2v-12a2 2 0 00-2-2z"/>
 <path d="m43.7 4.8a2 2 0 00-3.1-.2l-10.6 10.6v-7.1a2.1 2.1 0 00-1.7-2.1 2 2 0 00-2.3 2v12a2 2 0 002 2h11.9a2.1 2.1 0 002.1-1.7 2 2 0 00-2-2.3h-7.2l10.6-10.5a2.3 2.3 0 00.3-2.7z"/>
</svg>

</button>
          <button data-action="zoom-actual">1:1</button>
                <button class="close" aria-label="Close"><svg aria-hidden="true" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M12 2L2 12" stroke="currentColor" stroke-width="var(--icon-stroke-width)" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M12 12L2 2" stroke="currentColor" stroke-width="var(--icon-stroke-width)" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</button>
        </div>
      </div>

      <div class="viewport">
        <div class="track"></div>
      </div>

      <button class="prev" aria-label="Previous"><svg width="20" height="20" viewBox="0 0 20 20" aria-hidden="true">
            <path d="M12 15l-5-5 5-5" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
           </svg></button>
      <button class="next" aria-label="Next"><svg width="20" height="20" viewBox="0 0 20 20" aria-hidden="true">
            <path d="M8 5l5 5-5 5" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
           </svg></button>

      <div class="thumbs"></div>
    </div>
  `;
class BDLightbox extends HTMLElement {
  images = [];
  currentIndex = 0;
  zoomScale = 1;
  maxZoom = 4;

  // Swipe state
  swipeStartX = 0;
  swipeDeltaX = 0;
  isSwiping = false;

    connectedCallback() {
    const existingLightbox = document.querySelector('bd-lightbox');
    if (existingLightbox && existingLightbox !== this) {
      this.remove();
      return;
    }

    this.innerHTML = lightBoxHTML;

    this.overlay = this.querySelector(".overlay");
    this.window = this.querySelector(".window");
    this.track = this.querySelector(".track");
    this.counterEl = this.querySelector(".counter");
    this.viewport = this.querySelector(".viewport");
 
       document.addEventListener("click", (e) => {
      if (e.target.closest("bd-lightbox")) return;
      const zoomEl = e.target.closest("[data-zoom]");
      if (!zoomEl) return;

      const slider = zoomEl.closest("[data-zoom-container]");
      if (!slider) return;

      const zoomables = slider.querySelectorAll("[data-zoom] img");
      const images = [...zoomables].map((img) => ({
        low: img.currentSrc || img.src,   
        high: img.dataset.zoomSrc || img.src
      }));
      const index = [...zoomables].indexOf(zoomEl.querySelector("img"));

      this.open(images, index);
    });

    this.querySelector('[data-action="zoom-in"]').addEventListener("click", () => this.#zoomBy(0.25));
    this.querySelector('[data-action="zoom-out"]').addEventListener("click", () => this.#zoomBy(-0.25));
    this.querySelector('[data-action="zoom-fit"]').addEventListener("click", () => this.#zoomFit());
    this.querySelector('[data-action="zoom-actual"]').addEventListener("click", () => this.#zoomActual());

    this.querySelector(".close").addEventListener("click", (e) => { e.stopPropagation(); this.close(); });
    this.overlay.addEventListener("click", () => this.close());
    this.querySelector(".prev").addEventListener("click", () => this.#goTo(this.currentIndex - 1));
    this.querySelector(".next").addEventListener("click", () => this.#goTo(this.currentIndex + 1));

    document.addEventListener("keydown", (e) => {
      if (!this.classList.contains("is-open")) return;
      if (e.key === "Escape") this.close();
      if (e.key === "ArrowLeft") this.#goTo(this.currentIndex - 1);
      if (e.key === "ArrowRight") this.#goTo(this.currentIndex + 1);
    });
  }

  open(images, index = 0) {
    if (this.parentNode !== document.body) document.body.appendChild(this);

    this.images = images;
    this.currentIndex = index;
    
    this.classList.add("is-open");
    document.body.classList.add("overflow-hidden");
    
    this.#attachGlobalListeners();
    this.#renderSlide();
  }
  close() {
    this.classList.remove("is-open");
    document.body.classList.remove("overflow-hidden");
    this.track.innerHTML = "";
    this.images = [];
    
    if (this._globalMoveHandler) document.removeEventListener("pointermove", this._globalMoveHandler);
    if (this._globalUpHandler) document.removeEventListener("pointerup", this._globalUpHandler);
  }

  #goTo(newIndex) {
    if (newIndex < 0) newIndex = this.images.length - 1;
    if (newIndex >= this.images.length) newIndex = 0;
    if (newIndex === this.currentIndex) return;

    this.currentIndex = newIndex;
    this.#renderSlide();
  }

    #renderSlide() {
    this.track.innerHTML = "";
    this.zoomScale = 1;

    const slide = document.createElement("div");
    slide.className = "slide";
    
    const imageData = this.images[this.currentIndex];
    // ⭐ Support both object format { low, high } and legacy string format
    const lowSrc = typeof imageData === 'object' ? imageData.low : imageData;
    const highSrc = typeof imageData === 'object' ? imageData.high : imageData;
    const needsPlaceholder = lowSrc !== highSrc;
    
    // ⭐ Show low-res as CSS background immediately (no layout conflicts)
    if (needsPlaceholder) {
      slide.style.backgroundImage = `url(${lowSrc})`;
      slide.style.backgroundSize = 'contain';
      slide.style.backgroundPosition = 'center';
      slide.style.backgroundRepeat = 'no-repeat';
    }
    
    const img = document.createElement("img");
    img.src = highSrc;
    img.className = "img";
    // ⭐ Start invisible while high-res loads; visible immediately if no placeholder needed
    img.style.opacity = needsPlaceholder ? '0' : '1';
    
    slide.appendChild(img);
    this.track.appendChild(slide);

    this.counterEl.textContent = `${this.currentIndex + 1} / ${this.images.length}`;

    // ⭐ Centralized positioning logic (reused after high-res loads)
    const setupTransform = () => {
      // Clear the placeholder background
      slide.style.backgroundImage = '';
      
      const slideW = slide.clientWidth;
      const slideH = slide.clientHeight;
      const nw = img.naturalWidth;
      const nh = img.naturalHeight;

      if (nw === 0 || nh === 0) return;

      const baseScale = Math.min(1, slideW / nw, slideH / nh);
      img.dataset.baseScale = baseScale;
      
      this.maxZoom = baseScale === 1 ? img.naturalWidth / img.clientWidth : 1 / baseScale;

      img.dataset.tx = (slideW - (nw * baseScale)) / 2;
      img.dataset.ty = (slideH - (nh * baseScale)) / 2;
      
      const finalScale = this.zoomScale * baseScale;
      img.style.transform = `translate(${img.dataset.tx}px, ${img.dataset.ty}px) scale(${finalScale})`;
    };

    const onReady = () => {
      setupTransform();
      // ⭐ Fade in the high-res image over the placeholder
      if (needsPlaceholder) {
        img.style.transition = 'opacity 0.2s ease-out';
        img.style.opacity = '1';
        // Clean up transition after fade completes
        const onEnd = () => {
          img.style.transition = 'none';
          img.removeEventListener('transitionend', onEnd);
        };
        img.addEventListener('transitionend', onEnd);
        // Fallback cleanup in case transitionend doesn't fire
        setTimeout(() => { img.style.transition = 'none'; }, 250);
      }
    };

    if (img.complete && img.naturalHeight !== 0) {
      onReady();
    } else {
      img.onload = onReady;
      // ⭐ Fallback: if high-res fails, show the low-res instead of a blank screen
      img.onerror = () => {
        if (needsPlaceholder) {
          img.src = lowSrc;
          img.onload = onReady;
        }
      };
    }
  }

  // --- GLOBAL HANDLERS ---

  #attachGlobalListeners() {
    this._globalMoveHandler = (e) => {
      if (!this.isSwiping) return;
      this.swipeDeltaX = e.clientX - this.swipeStartX;
    };

    this._globalUpHandler = (e) => {
      if (!this.isSwiping) return;
      this.isSwiping = false;

      const threshold = 50;
      if (this.swipeDeltaX < -threshold) this.#goTo(this.currentIndex + 1);
      else if (this.swipeDeltaX > threshold) this.#goTo(this.currentIndex - 1);
    };

    document.addEventListener("pointermove", this._globalMoveHandler);
    document.addEventListener("pointerup", this._globalUpHandler);

    if (!this._internalListenersAttached) {
      this.#setupPermanentInternalListeners();
      this._internalListenersAttached = true;
    }
  }

  #setupPermanentInternalListeners() {
    this.track.addEventListener("dragstart", (e) => e.preventDefault());

    const pointers = new Map(); 
 
    let isPanning = false;
    let isPinching = false;
    let startX = 0, startY = 0;
    let initialPinchDist = 0;
    let pinchStartZoom = 1;
    let pinchStartTx = 0, pinchStartTy = 0;
    let pinchOriginX = 0, pinchOriginY = 0;

    this.track.addEventListener("pointerdown", (e) => {
      const img = this.track.querySelector(".slide img");
      if (!img) return;

      this._pointerStartPos = { x: e.clientX, y: e.clientY };

      pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
      this.track.setPointerCapture(e.pointerId);
 
      if (pointers.size === 2 && !isPinching) {
        isPinching = true;
        isPanning = false;
        this.isSwiping = false; 
        e.preventDefault();

        pinchStartZoom = this.zoomScale;
        pinchStartTx = parseFloat(img.dataset.tx) || 0;
        pinchStartTy = parseFloat(img.dataset.ty) || 0;

        const pts = [...pointers.values()];
        initialPinchDist = Math.hypot(pts[1].x - pts[0].x, pts[1].y - pts[0].y);
        
        const origin = this.#getImageOrigin(img, pinchStartTx, pinchStartTy);
        pinchOriginX = origin.x;
        pinchOriginY = origin.y;
        return;
      }

      if (pointers.size === 1 && !isPinching) {
        if (this.zoomScale <= 1) {
          this.swipeStartX = e.clientX;
          this.swipeDeltaX = 0;
          this.isSwiping = true;
        } else {
          isPanning = true;
          startX = e.clientX;
          startY = e.clientY;
        }
      }
    });

    this.track.addEventListener("pointermove", (e) => {
      const img = this.track.querySelector(".slide img");
      if (!img || !pointers.has(e.pointerId)) return;
      
      pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });

      if (isPinching && pointers.size === 2) {
        e.preventDefault();
        const pts = [...pointers.values()];
        const currentDist = Math.hypot(pts[1].x - pts[0].x, pts[1].y - pts[0].y);
        if (initialPinchDist === 0) return;

        const scaleDelta = currentDist / initialPinchDist;
        const nextScale = Math.min(Math.max(pinchStartZoom * scaleDelta, 1), this.maxZoom);
        const baseScale = parseFloat(img.dataset.baseScale) || 1;

        if (nextScale === 1) {
          const slide = this.track.querySelector(".slide");
          const slideW = slide.clientWidth;
          const slideH = slide.clientHeight;
          const scaledW = img.naturalWidth * baseScale;
          const scaledH = img.naturalHeight * baseScale;
          img.dataset.tx = (slideW - scaledW) / 2;
          img.dataset.ty = (slideH - scaledH) / 2;
        } else {
          const midX = (pts[0].x + pts[1].x) / 2 - pinchOriginX;
          const midY = (pts[0].y + pts[1].y) / 2 - pinchOriginY;
          const scaleFactor = (nextScale * baseScale) / (pinchStartZoom * baseScale);
          
          img.dataset.tx = pinchStartTx - midX * (scaleFactor - 1);
          img.dataset.ty = pinchStartTy - midY * (scaleFactor - 1);
        }

        this.zoomScale = nextScale;
        this.#applyTransform(img, false);
        return;
      }

      if (isPanning && pointers.size === 1) {
        e.preventDefault();
        const dx = e.clientX - startX;
        const dy = e.clientY - startY;
        pointers.get(e.pointerId).totalDx = (pointers.get(e.pointerId).totalDx || 0) + Math.abs(dx);
        
        img.dataset.tx = parseFloat(img.dataset.tx || 0) + dx;
        img.dataset.ty = parseFloat(img.dataset.ty || 0) + dy;
        this.#applyTransform(img, false);
        startX = e.clientX;
        startY = e.clientY;
      }
    });

    const endPointer = (e) => {
      const p = pointers.get(e.pointerId);
      if (p && p.totalDx > 5) this._wasDragging = true;

      pointers.delete(e.pointerId);
      if (pointers.size === 0) {
        isPanning = false;
        isPinching = false;
      } else if (isPinching && pointers.size === 1) {
        isPinching = false;
        isPanning = this.zoomScale > 1;
        const remaining = [...pointers.values()][0];
        startX = remaining.x;
        startY = remaining.y;
      }
    };

    this.track.addEventListener("pointerup", endPointer);
    this.track.addEventListener("pointercancel", endPointer);

    this.track.addEventListener("click", (e) => {
      if (Math.abs(this.swipeDeltaX) > 5) return;
      if (isPinching || pointers.size > 0) return;

      if (this._pointerStartPos) {
        const dx = Math.abs(e.clientX - this._pointerStartPos.x);
        const dy = Math.abs(e.clientY - this._pointerStartPos.y);
        if (dx > 5 || dy > 5) return;
      }

      this.#smartZoom(e);
    });

    this.track.addEventListener("dblclick", (e) => {
      if (this.zoomScale > 1) this.#zoomFit();
      else this.#maxZoomAtPoint(e);
    });

    this.track.addEventListener("wheel", (e) => {
      const img = this.track.querySelector(".slide img");
      if (!img) return;
      
      e.preventDefault();
      const prevScale = this.zoomScale;
      const nextScale = Math.min(Math.max(prevScale + (e.deltaY > 0 ? -0.15 : 0.15), 1), this.maxZoom);
      if (nextScale === prevScale) return;

      const result = this.#calculateZoom(img, e.clientX, e.clientY, nextScale);
      this.zoomScale = result.scale;
      img.dataset.tx = result.tx;
      img.dataset.ty = result.ty;
      this.#applyTransform(img, false);
    }, { passive: false });
  }

  // --- CORE MATH ENGINE ---

  #getImageOrigin(img, tx, ty) {
    const slide = img.closest('.slide');
    const slideRect = slide.getBoundingClientRect();
    return {
      x: slideRect.left + tx,
      y: slideRect.top + ty
    };
  }

  #calculateZoom(img, clientX, clientY, newZoomScale) {
    const tx = parseFloat(img.dataset.tx) || 0;
    const ty = parseFloat(img.dataset.ty) || 0;
    const prevScale = this.zoomScale;
    const baseScale = parseFloat(img.dataset.baseScale) || 1;

    if (newZoomScale === 1) {
      const slide = img.closest('.slide');
      const slideW = slide.clientWidth;
      const slideH = slide.clientHeight;
      const scaledW = img.naturalWidth * baseScale;
      const scaledH = img.naturalHeight * baseScale;
      return { tx: (slideW - scaledW) / 2, ty: (slideH - scaledH) / 2, scale: 1 };
    }

    const origin = this.#getImageOrigin(img, tx, ty);
    const cx = clientX - origin.x;
    const cy = clientY - origin.y;
    const scaleFactor = (newZoomScale * baseScale) / (prevScale * baseScale);
    
    return {
      tx: tx - cx * (scaleFactor - 1),
      ty: ty - cy * (scaleFactor - 1),
      scale: newZoomScale
    };
  }

  #applyTransform(img, animate = false) {
    const baseScale = parseFloat(img.dataset.baseScale) || 1;
    const finalScale = this.zoomScale * baseScale;
    const tx = parseFloat(img.dataset.tx || 0);
    const ty = parseFloat(img.dataset.ty || 0);

    if (animate) {
      img.style.transition = 'transform 0.2s ease-out';
    } else {
      img.style.transition = 'none';
    }

    img.style.transform = `translate(${tx}px, ${ty}px) scale(${finalScale})`;
    
    if (animate) {
      const onEnd = () => {
        img.style.transition = 'none';
        img.removeEventListener('transitionend', onEnd);
      };
      img.addEventListener('transitionend', onEnd);
    }
  }

  // --- TOOLBAR ACTIONS ---

  #getActiveImg() {
    return this.track.querySelector(".slide img");
  }

  #zoomBy(delta) {
    const img = this.#getActiveImg();
    if (!img) return;
    const newScale = Math.min(Math.max(this.zoomScale + delta, 1), this.maxZoom);
    if (newScale === this.zoomScale) return;

    const rect = this.viewport.getBoundingClientRect();
    const center = this.#calculateZoom(img, rect.left + rect.width/2, rect.top + rect.height/2, newScale);
    this.zoomScale = center.scale;
    img.dataset.tx = center.tx;
    img.dataset.ty = center.ty;
    this.#applyTransform(img, true); 
  }

  #zoomFit() {
    const img = this.#getActiveImg();
    if (!img) return;
    this.zoomScale = 1.0001; 
    const result = this.#calculateZoom(img, 0, 0, 1);
    this.zoomScale = 1;
    img.dataset.tx = result.tx;
    img.dataset.ty = result.ty;
    this.#applyTransform(img, true); 
  }

  #zoomActual() {
    const img = this.#getActiveImg();
    if (!img) return;
    const baseScale = parseFloat(img.dataset.baseScale) || 1;
    const newScale = baseScale === 1 ? img.naturalWidth / img.clientWidth : 1 / baseScale;
    
    if (newScale === this.zoomScale) {
      const rect = this.viewport.getBoundingClientRect();
      const center = this.#calculateZoom(img, rect.left + rect.width/2, rect.top + rect.height/2, newScale);
      img.dataset.tx = center.tx;
      img.dataset.ty = center.ty;
      this.#applyTransform(img, true);
      return;
    }

    const rect = this.viewport.getBoundingClientRect();
    const center = this.#calculateZoom(img, rect.left + rect.width/2, rect.top + rect.height/2, newScale);
    this.zoomScale = center.scale;
    img.dataset.tx = center.tx;
    img.dataset.ty = center.ty;
    this.#applyTransform(img, true); 
  }

  #smartZoom(e) {
    const img = this.#getActiveImg();
    if (!img) return;
    
    const nextStep = this.zoomScale + 1;
    const newScale = this.zoomScale < this.maxZoom ? Math.min(nextStep, this.maxZoom) : 1;
    
    const result = this.#calculateZoom(img, e.clientX, e.clientY, newScale);
    this.zoomScale = result.scale;
    img.dataset.tx = result.tx;
    img.dataset.ty = result.ty;
    this.#applyTransform(img, false); 
  }

  #maxZoomAtPoint(e) {
    const img = this.#getActiveImg();
    if (!img) return;
    const result = this.#calculateZoom(img, e.clientX, e.clientY, this.maxZoom);
    this.zoomScale = result.scale;
    img.dataset.tx = result.tx;
    img.dataset.ty = result.ty;
    this.#applyTransform(img, false);
  }
}

customElements.define("bd-lightbox", BDLightbox);